import { FormattedMessage as FM } from "react-intl";

function MenuActionReport({ report, handleClick }) {
  console.log("Dosn't use htis component:  MenuActionReport use Menu Button");
  return (
    <div
      key={report.name}
      className="flex px-3 py-2 relative gap-x-6 rounded-lg hover:bg-stone-100 hover:text-sky-700 hover:cursor-pointer"
      onClick={() => handleClick(report)}
    >
      <div className="grid">
        <p className="">
          <FM id={report.description} />
        </p>
        {/* {report.description && (
          <p className="text-stone-400 mt-2">
            <FM id={report.description} />
          </p>
        )}*/}
      </div>
    </div>
  );
}

export default MenuActionReport;
